import { useState } from 'react';
import { Tab, TabList, TabPanel, Tabs } from 'react-tabs';
import 'react-tabs/style/react-tabs.css';
import ConfigFormLanding from './ConfigFormLanding';
import BulkInviteForm from './BulkInvite/BulkInviteForm';

const InvitedPersonsPage = () => {
  const [refreshKey, setRefreshKey] = useState(0);

  return (
    <div className="main-body-page grow" data-testid="invited-persons-page">
      <Tabs>
        <TabList>
          <Tab>Bulk Invite</Tab>
          <Tab>Invite Manager</Tab>
        </TabList>
        <TabPanel>
          <BulkInviteForm onInvited={() => setRefreshKey((k) => k + 1)} />
        </TabPanel>
        <TabPanel>
          <ConfigFormLanding key={refreshKey} type="invite" />
        </TabPanel>
      </Tabs>
    </div>
  );
};

export default InvitedPersonsPage;
